import { Message } from 'element-ui'
import nprogress from 'nprogress'
import router from './router'
import store from './store'

import 'nprogress/nprogress.css'

nprogress.configure({ showSpinner: false })

router.beforeEach((to, from, next) => {
  nprogress.start()

  const isLogin = localStorage.login === 'success'
  const isToLoginPage = to.path === '/login'

  // 没登录的情况下需要跳转到登录页面
  if (!isLogin) return isToLoginPage ? next() : next({ path: '/login' })

  // 如果登录了还跳转到白名单则重定向回首页
  if (isToLoginPage) return next({ path: '/' })

  // 获取过权限则进入下个页面
  if (store.getters.menus.length > 0) return next()

  store
    .dispatch('getUserInfo')
    .then((res) => {
      const { menus } = res.result

      store.dispatch('generateRoutes', menus).then(() => {
        router.addRoutes(store.getters.addRouters)
        next({ ...to, replace: true })
      })
    })
    .catch((err) => {
      console.log(3444, err)
      store.dispatch('logout').then(() => {
        Message.error('获取权限失败，请重新登录')
        next({ path: '/' })
      })
    })

  return null
})

router.afterEach(() => {
  nprogress.done()
})
